var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcSmallArrowRight = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "hd94ussi8a",
    x: 0,
    y: 0,
    width: 55,
    height: 55,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#bcbcbc"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1546"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#hd94ussi8a)"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 16",
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    transform: "translate(14.996 14.002)",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 818",
    d: "m12030.038-584.914 5.344-4.947-5.344-5.344",
    transform: "translate(-12004.939 616.433)",
    style: {
      fill: "none",
      stroke: "#666",
      strokeWidth: 3
    }
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcSmallArrowRight);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic-smallArrowRight.cb20e1b302b6db3a142878b4610a2f37.svg";